import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06ebe588&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=06ebe588&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebe588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ebe588')) {
      api.createRecord('06ebe588', component.options)
    } else {
      api.reload('06ebe588', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06ebe588&scoped=true&lang=pug", function () {
      api.rerender('06ebe588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/courseRecordVideo/index.vue"
export default component.exports